export const RP_TPA_DAILY_MODEL_LIST = 'RP_TPA_DAILY_MODEL_LIST'
export const RP_TPA_DAILY_SEARCH = 'RP_TPA_DAILY_SEARCH'
export const RP_TPA_DAILY_PAGINATION = 'RP_TPA_DAILY_PAGINATION'